import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { css } from '@emotion/react';

// types
import { PLPFilterOptions } from 'pages/WebsiteDesignsPLPSSR/helpers';

// redux
import { useAppSelector } from 'reducers/useAppSelector';

// components
import { FilterPill } from '@zola/zola-ui/src/components/FilterPill';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

// styles
import {
  hideWhenDesktop,
  hideWhenTabletAndMobile,
} from 'pages/WebsiteDesignsPLPV2/WebsiteDesignsPLPV2.styles';
import {
  PillContainer,
  StylesLinkLgDevices,
  StylesLinkSmDevices,
} from './PLPCurrentFilters.styles';

export type PLPCurrentFiltersProps = {
  onUpdateFilter: (filters: PLPFilterOptions) => void;
};

const PLPCurrentFilters: React.FC<PLPCurrentFiltersProps> = ({ onUpdateFilter }) => {
  const currentFilters = useAppSelector(state => state.websitePlp.applied_filters);
  const facets = useAppSelector(state => state.websitePlp.facets);

  const filteredFacets = facets.filter(facet => facet.field !== 'layout_types');

  const facetsMap: Record<string, Record<string, string>> = {};
  filteredFacets.forEach(facetGroup => {
    if (facetGroup && facetGroup.field) {
      facetsMap[facetGroup.field] = {};
      if (facetGroup.buckets && facetGroup.buckets.length > 0) {
        facetGroup.buckets.forEach(facetOption => {
          // TODO: Need to figure out how to make TS happy with this nested structure
          // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
          facetsMap[facetGroup.field][facetOption.value] = facetOption.name;
        });
      }
    }
  });
  const { colors = [], motifs = [] } = currentFilters;
  const flattenedFilters = [...colors, ...motifs];

  if (!flattenedFilters || flattenedFilters.length === 0) return null;

  return (
    <PillContainer data-testid="PLPCurrentFilters">
      {flattenedFilters.length > 1 && (
        <LinkV2
          css={css`
            ${hideWhenDesktop}
            ${StylesLinkSmDevices};
          `}
          role="button"
          inline
          onClick={() => {
            onUpdateFilter({ colors: [], motifs: [], special_features: [] });
          }}
        >
          Clear
        </LinkV2>
      )}
      {!_isEmpty(facetsMap) &&
        Object.keys(currentFilters).map(fieldName => {
          const fieldNameValues = currentFilters[fieldName as keyof typeof currentFilters];
          return fieldNameValues.map((filter: string) => {
            const filterLabel = facetsMap[fieldName][filter];
            return (
              <FilterPill
                key={filter}
                label={filterLabel}
                handlePillClick={() => {
                  const updatedFilters = {
                    ...currentFilters,
                    [fieldName]: currentFilters[fieldName as keyof typeof currentFilters].filter(
                      f => f !== filter
                    ),
                  };
                  onUpdateFilter(updatedFilters);
                }}
              />
            );
          });
        })}
      {flattenedFilters.length > 1 && (
        <LinkV2
          css={css`
            ${hideWhenTabletAndMobile}
            ${StylesLinkLgDevices};
          `}
          role="button"
          inline
          onClick={() => {
            onUpdateFilter({ colors: [], motifs: [], special_features: [] });
          }}
        >
          Clear
        </LinkV2>
      )}
    </PillContainer>
  );
};

export default PLPCurrentFilters;
